/**
 * Read More/ Read Less
 * -------------------------------------------------------
 * Used to for read more/ read less on the global-media-text-full-width snippet.
 * -------------------------------------------------------
 */

import {
    registerLegacySalvoLiteComponent,
    legacySalvoLiteLog as log
} from '@eastsideco/salvo-ts';

class ReadMorePdp {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
    }
    onInit () {

        const fullCopy = document.querySelector('.extend-text');
        const shortCopy = document.querySelector('.short-text');
        const readLess = document.querySelector('.read-less');

        if (fullCopy === null || shortCopy === null || readLess === null) return;

        const toggleHidden = () => {
            shortCopy.classList.toggle('hidden');
            fullCopy.classList.toggle('hidden');
        };

        this._elem.addEventListener('click', () => {
            toggleHidden();
        }); 

        readLess.addEventListener('click', () => {
            toggleHidden();
        });
        
    };
};

export default registerLegacySalvoLiteComponent({
    component: ReadMorePdp,
    selector: '[data-read-more-pdp]', // Required
});